import Navbar from "../../navbar/Navbar";
import { useState, useEffect } from "react";

import LocationCode from "../../utils/constants/LocationCode";
import AdminMenuId from "../../utils/constants/AdminMenuId";
import AdminContent from "./AdminContent";

let AdminPage = (props) => {
    let [location, setLocation] = useState(LocationCode.NOT_LOADING);
    let [currentMenu, setCurrenetMenu] = useState(AdminMenuId.TABLE);

    useEffect(() => {
        setLocation(props.myInformation.location)
    }, [props.myInformation])
    return (
        <>
            <Navbar location={location} onLocationChange={setLocation.bind(this)}
                currentMenu={currentMenu}
                onMenuChange={setCurrenetMenu.bind(this)}
                onLoginChange={props.onLoginChange} isAdmin={true}
                myInformation={props.myInformation}
            ></Navbar>
            <AdminContent currentMenu={currentMenu} data={props.data} location={location}
                          myInformation={props.myInformation}></AdminContent>
        </>
    )
}
export default AdminPage;